// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c8860eca","455":"8a65e2a9","488":"148118ec","977":"98cb7b6f"}[chunkId] + ".chunk.js";
};